import React, { Context, ReactNode } from 'react';
import { useMachine } from '@xstate/react';

import { taskMachine } from './taskMachine';

interface TasksProviderProps {
    children: ReactNode;
    TasksContext: Context<TasksProviderValue>;
}

/**
 * Returns a Provider component that exposes the details of the tasks state machine. See the
 * {@link https://reactjs.org/docs/context.html#contextprovider | Provider docs}.
 * @param props - {@link TasksProviderProps}
 * @returns JSX
 */
export const TasksProvider = ({
    children,
    TasksContext,
}: TasksProviderProps): JSX.Element => {
    const [taskMachineState, sendTaskEvent, taskMachineService] = useMachine<
        TaskContext,
        TaskEvent,
        TaskTypeState
    >(taskMachine);

    return (
        <TasksContext.Provider
            value={{
                sendTaskEvent,
                taskMachineService,
                taskMachineState,
            }}
        >
            {children}
        </TasksContext.Provider>
    );
};
